import { Button } from 'components/core';
import './WheelPageFooter.styl';
import { useStoreContext } from 'store/app';
import { observer } from 'mobx-react-lite';
import { useTranslationsContext } from 'store/translations';
import { IRewardState, ShortLinkType } from 'src/types';

interface WheelPageFooterProps {
    onClick: () => void;
    title: string;
    subtitle: string;
    btnText: string;
    btnDisabled?: boolean;
    providerLink?: string;
    reward?: IRewardState;
}

export const WheelPageFooter = observer(
    ({ onClick, btnDisabled, title, subtitle, btnText, providerLink, reward }: WheelPageFooterProps) => {
        const { openLink } = useStoreContext();
        const { translate } = useTranslationsContext();

        return (
            <div className="wheel-page-footer">
                <span className="wheel-page-footer-title">{title}</span>
                <span className="wheel-page-footer-subtitle">{subtitle}</span>
                <Button className="wheel-page-footer-button" onClick={onClick} disabled={btnDisabled}>
                    {btnText}
                </Button>
                {providerLink && (
                    <Button
                        className="wheel-page-footer-button-provider"
                        onClick={() =>
                            openLink(
                                providerLink,
                                true,
                                reward ? { type: ShortLinkType.REWARD, subtype: reward.id } : undefined
                            )
                        }
                    >
                        {translate('wheel.prize.about')}
                    </Button>
                )}
            </div>
        );
    }
);
